import React from 'react';
import ArrowUp from '../../icons/ArrowUp.svg?react';
import ArrowDown from '../../icons/ArrowDown.svg?react';
import style from './style.module.scss';

interface TrendArrowProps {
    value: number;
    size?: number;
    showPercentage?: boolean;
    className?: string;
    /** When false, a lower value is better (error rate, failed sessions, churn):
     * only the COLOUR flips, so a decrease reads positive/green and an increase
     * negative/red. The arrow still points the real direction of change.
     * Defaults to true (higher is better). */
    positiveIsGood?: boolean;
}

export const TrendArrow: React.FC<TrendArrowProps> = ({
    value,
    size = 32,
    showPercentage = true,
    className = '',
    positiveIsGood = true,
}) => {
    const goodClass = style.trend_arrow_positive;
    const badClass = style.trend_arrow_negative;

    if (value > 0) {
        return (
            <span
                className={`${
                    positiveIsGood ? goodClass : badClass
                } ${className}`}
            >
                <ArrowUp width={size} height={size} />
                {showPercentage && `${value.toFixed(2)}%`}
            </span>
        );
    }

    if (value < 0) {
        return (
            <span
                className={`${
                    positiveIsGood ? badClass : goodClass
                } ${className}`}
            >
                <ArrowDown width={size} height={size} />
                {showPercentage && `${Math.abs(value).toFixed(2)}%`}
            </span>
        );
    }

    return (
        <span className={`${style.trend_arrow_neutral} ${className}`}>
            {showPercentage ? '0.00%' : '0'}
        </span>
    );
};

export const getTrendArrowIcon = (
    isPositive: boolean | undefined,
    size = 32
): React.ReactElement | null => {
    if (isPositive === undefined) {
        return null;
    }
    return isPositive ? (
        <ArrowUp width={size} height={size} />
    ) : (
        <ArrowDown width={size} height={size} />
    );
};
